// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"9bb6f7dc","239":"98267e4f","453":"bb3ec1d6","732":"d4777fc5"}[chunkId] + ".chunk.js";
};